import React from "react";
import { CustomizationController } from "../types/customization_controller";

export const CustomizationControllerContext = React.createContext<CustomizationController>({} as CustomizationController);
